"use client";
import React from "react";
import { Button } from "./ui/button";
import axios from "axios";

type Props = {
  isPro: boolean;
  billingPeriod: 'monthly' | 'yearly';
  className?: string;
};

const SubscriptionButton = ({ isPro, billingPeriod, className = "" }: Props) => {
  const [loading, setLoading] = React.useState(false);
  const handleSubscription = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/stripe?billingPeriod=${billingPeriod}`);
      window.location.href = response.data.url;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button 
      disabled={loading} 
      onClick={handleSubscription} 
      className={`${className} ${isPro ? "" : "animated-gradient"}`}
    >
      {isPro ? "Manage Subscription" : "Get Started"}
    </Button>
  );
};

export default SubscriptionButton;